import {createApp} from "vue";
import FloatingVue from 'floating-vue';

import Loader from "@/js/Plugins/Loader.js";
import Store from "@/js/Plugins/Store.js";
import Locale from "@/js/Plugins/Locale.js";
import Http from "@/js/Plugins/Http.js";
import Notify from '@/js/Plugins/Notify.js';
import Provider from "@/js/Plugins/Provider.js";
import Theme from "@/js/Plugins/Theme.js";
import Emitter from "@/js/Plugins/Emitter.js";
import Popup from "@/js/Plugins/Popup.js";
import ErrorHandler from "@/js/Plugins/ErrorHandler.js";
import ServiceWorker from "@/js/Plugins/ServiceWorker.js";
import Modal from '@/js/Plugins/Modal.js';

export function useApp(Component, setup) {
    return createApp(Component)
        .use(ErrorHandler, {
            dev: import.meta.env?.VITE_DEV_MODE === 'true',
            bugsnagKey: import.meta.env?.VITE_BUGSNAG_API_KEY || '21550dec9a51e045a499c83059ccf698'
        })
        .use(FloatingVue)
        .use(Emitter)
        .use(Notify, {
            maxNotifications: 5,
        })
        .use(Popup)
        .use(Loader, {
            transition: 250
        })
        .use(Provider)
        .use(Store, setup?.auth)
        .use(Locale, {
            lang: setup.lang,
            locale: setup?.lang_locale,
            dow: setup?.dow,
            dir: setup?.lang_dir,
            messages: setup.translations,
            time_format: setup?.locale?.time_format || 'H:i',
            date_format: setup?.locale?.date_format || 'Y-m-d',
            week_start_day: setup?.locale?.week_start_day,
        })
        .use(Modal)
        .use(Http)
        .use(Theme)
        .use(ServiceWorker);
}